import PersonalAddress from "./PersonalAddress";

export default PersonalAddress;
